import type { Wallet } from '../../../schema/frameworks/entry.js';

export interface IWallet {
  get isMarketplaceWallet(): boolean;
}

export class WalletEntity implements IWallet {
  private readonly _model: Wallet;
  constructor(model: Wallet) {
    this._model = model;
  }

  get isMarketplaceWallet(): boolean {
    const marketplaceWallets: Wallet['type'][] = ['WALLET_MARKETPLACE_PLAYER', 'WALLET_MARKETPLACE_RETAILER'];

    return marketplaceWallets.includes(this._model.type);
  }
}
